import { Injectable } from '@angular/core';
//import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/retry';

/**
 * WEB-API-SERVICE
 * version: 1.0.0 - 31-Ene-2018
 * 
 */
@Injectable()
export class WebapiService {

    domain: string = "ceramicamx-api.lalotech.net";
    //domain: string = "app.ceramicamx.com";
    //domain: string = "localhost:8092";
    protocol:string = "https";
    public fullpath:string;
    timeoutTimeMs = 10*1000; //10 seg
    headers;   

    constructor(private http: HttpClient) {
        this.headers  = new HttpHeaders(
            {"Content-Type":"application/json;charset=urf-8","Pragma":"no-cache"}
        )        
        this.fullpath = this.protocol+"://"+this.domain+"/";
    }
    addHeader(name: string, value: string) {
        if (this.headers.has(name))
            this.headers.delete(name);
        this.headers.append(name, value);
    }
    removeHeader(name: string) {
        if (this.headers.has(name))
            this.headers.delete(name);
        //this.buildOptions();
    }
    buildOptions() {
        //this.options = new RequestOptions({ headers: this.headers });
    }
    sPost(url:string,data:any): Promise<any>{
        return this.post(this.fullpath+url,data);
    }
    sGet(url: string): Promise<any> {              
        return this.http
            .get(this.fullpath+url, {'headers':this.headers})
            .retry(3)
            .timeout(this.timeoutTimeMs)
            .toPromise()
            
    }
    post(url: string, param: any): Promise<any> {        
        let body = JSON.stringify(param);
        //console.log("url: "+url+" body: "+body);
        //console.log("headers: "+JSON.stringify(this.options));
        return this.http
            .post(url, body, {'headers':this.headers})
            .retry(3)
            .timeout(this.timeoutTimeMs)
            .toPromise();
    }

    get(url: string): Promise<any> {        
        return this.http
            .get(url, {'headers':this.headers})            
            .retry(3)
            .timeout(this.timeoutTimeMs)
            .toPromise();
    }
    config(domain: string) {
        this.domain = domain;
    }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/services/core/webapi.service.ts